var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "51px",
    height: "51px",
    viewBox: "0 0 51 51",
    enableBackground: "new 0 0 51 51",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M41.955,17.129c-0.803-0.075-1.371,0.499-1.604,0.736L25.589,32.681l-1.176-1.175 c-3.104-3.111-6.216-6.223-9.328-9.334l-3.378-3.385c-0.372-0.378-0.71-0.725-1.076-1.05c-0.499-0.444-1.146-0.614-1.72-0.448 c-0.601,0.169-1.072,0.667-1.266,1.334c-0.198,0.698-0.022,1.239,0.608,1.864l14.781,14.774l-0.014,0.015l2.564,2.563l12.415-12.466 c0.123-0.123,0.32-0.311,0.562-0.509l1.18-1.185c1.109-1.11,2.215-2.215,3.32-3.325c0.376-0.377,0.566-0.811,0.566-1.29 c0-0.215-0.04-0.448-0.119-0.69C43.249,17.613,42.74,17.204,41.955,17.129z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDown);
export default __webpack_public_path__ + "static/media/DropDown.6bff0eea942384d8fd0d0652dcd6cf29.svg";
export { ForwardRef as ReactComponent };